'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import AlertBanner from './AlertBanner';
export default function AlertBannerWrapper() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = <AlertBanner key={pathname} />;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}